// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6796) return "static/chunks/6796-c7ed1029315ce5d6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2112":"744d511fe30567c3","4728":"946947d641c7c264","8419":"b64bfc9dee3873cd","9212":"5f8bbf55a4cee7bd","9919":"6b3e7c68535d5fbc"}[chunkId] + ".js";
};